// extracted by mini-css-extract-plugin
module.exports = {"desktop":"OutlookButton_desktop__7UBg0","mobile":"OutlookButton_mobile__uVBGy"};